import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

import { useSignupPopup } from 'src/components/SignUp/useSignUpPopup';

const SignupButtonWithPopup = ({
  buttonClassName = 'btn primary big block',
  handleSignUpClick,
  labelMessageLink = 'sign up',
  labelMessagePopup = '',
  linkClassName = 'btn primary big block',
  signup,
}) => {
  const { openSignupPopup } = useSignupPopup();

  const showInPopup = SiteConfigManager.getConfig('config.config.registration.showInPopup');

  return (
    <>
      {showInPopup ? (
        <button className={`${buttonClassName}`} onClick={openSignupPopup}>
          <Label message={labelMessagePopup} />
        </button>
      ) : (
        <Link className={`${linkClassName}`} onClick={handleSignUpClick} to={signup}>
          <Label message={labelMessageLink} />
        </Link>
      )}
    </>
  );
};

SignupButtonWithPopup.propTypes = {
  buttonClassName: PropTypes.string,
  handleSignUpClick: PropTypes.func,
  labelMessageLink: PropTypes.string,
  labelMessagePopup: PropTypes.string,
  linkClassName: PropTypes.string,
  signup: PropTypes.bool,
};

export default SignupButtonWithPopup;
